const service = window.abp.localization

export default {
  localize(key) {
    return service.localize(key)
  },
  getCurrentLanguage() {
    return service.currentCulture
  },
  getLanguages() {
    let languages = {}
    service.languages.map(function (lang) {
      languages[lang.name] = lang.displayName
    })
    languages.current = this.getCurrentLanguage().name
    return { lang: languages }
  },
  getAlpacaLocale() {
    if (_.includes(this.getCurrentLanguage().name, 'fr')) {
      return 'fr_FR'
    } else {
      return 'en_US'
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/services/Localization.js